import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { fontText, StylesIndexInjections } from 'common-react';

interface StyleProps {
  isActive?: boolean;
  variant?: 'longTitle' | 'shortTitle';
}

export default makeUiStyles((theme: Theme) => createStyles({
  table: {
    width: '100%',
    '& $firstColumn, $firstColumnHeader': {
      display: 'flex',
      justifyContent: 'flex-start',
    },
    '& $secondColumn, $secondColumnHeader': {
      display: 'flex',
      justifyContent: 'flex-start',
      marginRight: 70,
      minWidth: 130,
      flex: '0 0 130px',
      [theme.breakpoints.down('sm')]: {
        flex: '1 1 auto',
        width: 'auto',
        minWidth: 0,
        marginRight: 0,
      },
    },
    '& $thirdColumn, $thirdColumnHeader': {
      display: 'flex',
      justifyContent: 'flex-end',
      minWidth: 160,
      flex: '0 0 160px',
      [theme.breakpoints.down('sm')]: {
        flex: 'auto',
        width: 'max-content',
        minWidth: 0,
        marginLeft: 'auto',
      },
    },
    [theme.breakpoints.down('sm')]: {
      '& tr': {
        display: 'grid',
        alignItems: 'center',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '16px 8px',
      }
    },
  },
  tableHeader: {
    padding: '0 0 8px 0',
    display: 'flex',
    width: '100%',
    '& > th': {
      display: 'flex',
      alignItems: 'center',
    },
    '& > th:first-child': {
      flex: '1 1 auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
    },
    '& > th:last-child': {
      flex: '0 0 auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
    borderBottom: `1px solid ${theme.color.greys[10]}`,
  },
  tableRow: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '16px 0',
    borderBottom: `1px solid ${theme.color.greys[15]}`,
    '&:last-child': {
      borderBottom: 'none',
    },
    transition: '0.1s box-shadow',
    boxShadow: ({ isActive }: StyleProps) => (isActive ? theme.boxShadow.small : 'none'),
  },
  firstColumn: {
    minWidth: ({ variant }: StyleProps) => (variant === 'longTitle' ? 220 : 70),
    flex: '1 1 auto',
    display: 'flex',
    alignItems: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      width: ({ variant }: StyleProps) => (variant === 'longTitle' ? 120 : 70),
      minWidth: () =>0,
    },
  },
  secondColumn: {
    font: fontText('normal', theme.fontSize.base, 18),
    flex: '0 0 130px',
    justifyContent: 'flex-start',
    textAlign: 'left',
    marginRight: 70,
    [theme.breakpoints.down('sm')]: {
      flex: '1 1 auto',
      width: ({ variant }: StyleProps) => (variant === 'longTitle' ? 90 : 70),
      minWidth: 0,
      marginRight: 0,
    },
  },
  thirdColumn: {
    display: 'flex',
    justifyContent: 'flex-end',
    flex: '0 0 160px',
    minWidth: 160,
    '& > span:first-of-type': {
      marginLeft: 2,
    },
  },
  firstColumnHeader: {
    minWidth: ({ variant }: StyleProps) => (variant === 'longTitle' ? 220 : 70),
    flex: '1 1 auto',
    display: 'flex',
    alignItems: 'center',
    color: theme.color.greys[60],
    [theme.breakpoints.down('sm')]: {
      width: ({ variant }: StyleProps) => (variant === 'longTitle' ? 120 : 70),
      minWidth: () => 0,
    },
  },
  secondColumnHeader: {
    color: theme.color.greys[60],
    flex: '0 0 130px',
    display: 'flex',
    width: 130,
    alignItems: 'center',
    justifyContent: 'flex-start',
    textAlign: 'left',
    marginRight: 70,
    [theme.breakpoints.down('sm')]: {
      flex: '1 1 auto',
      width: 'auto',
      minWidth: 0,
      marginRight: 0,
    },
  },
  thirdColumnHeader: {
    color: theme.color.greys[60],
    flex: '0 0 160px',
    display: 'flex',
    width: 160,
    alignItems: 'center',
    justifyContent: 'flex-end',
    textAlign: 'right',
    minWidth: 160,
  },
}), { name: 'PortfolioTable', index: StylesIndexInjections.OTHER });

